<template lang="pug">
  section.socials#socials(v-lazyload)
    .container
      SocialsTitle
      SocialsList(v-if="items.length")
      SocialsPreloader(v-else)
      SocialsLinks
</template>

<script>
import { mapState, mapActions } from 'vuex'

import SocialsTitle from '@/components/socials/SocialsTitle'
import SocialsList from '@/components/socials/SocialsList'
import SocialsLinks from '@/components/socials/SocialsLinks'
import SocialsPreloader from '@/components/socials/SocialsPreloader'
import inViewport from '@/helpers/inViewport'

export default {
  name: 'Socials',
  components: {
    SocialsPreloader,
    SocialsLinks,
    SocialsList,
    SocialsTitle
  },
  computed: {
    ...mapState('socials', ['items']),
    ...mapState('siteVersions', {
      currentCountry: state => state.item
    })
  },
  watch: {
    currentCountry () {
      this.$nextTick(() => {
        inViewport(this.$el, this.fetch, 'offset')
      })
    }
  },
  methods: {
    ...mapActions('socials', ['fetch'])
  }
}
</script>
